import { Link } from "react-router-dom";

function Navbar({ pageTitle }) {
  return (
    <header className="font-poor-story">
      <div className="bg-orange h-20 w-20 rounded-b-full flex justify-center items-center">
        <Link to="/">
          <img
            src={require("../assets/icons/left arrow.png")}
            alt="arrow"
            className="w-10 cursor-pointer hover:motion-safe:animate-bounce "
          />
        </Link>
      </div>
      <div className="flex items-center justify-center text-4xl text-white uppercase">
        <h1>{pageTitle}</h1>
      </div>
    </header>
  );
}

export default Navbar;
